import { avatarDataUri } from "../utils/avatar";

// Renders a user's avataaars avatar if they have one enabled, else a colored initial dot.
export const Avatar = ({ avatar, username, color = "#7B0099", size = 32, className = "", ...rest }) => {
  const hasAvatar = avatar && avatar.enabled && avatar.options;
  if (hasAvatar) {
    return (
      <img
        src={avatarDataUri(avatar.options, size * 2)}
        alt={username || "avatar"}
        width={size}
        height={size}
        className={`rounded-full object-cover ${className}`}
        style={{ width: size, height: size }}
        {...rest}
      />
    );
  }
  return (
    <div
      className={`rounded-full flex items-center justify-center text-white font-bold ${className}`}
      style={{ width: size, height: size, backgroundColor: color, fontSize: size * 0.45 }}
      {...rest}
    >
      {(username || "?").charAt(0).toUpperCase()}
    </div>
  );
};

export default Avatar;
